import { useTranslation } from 'react-i18next';
import { EmptyText } from '@/components/Ui/EmptyText';
import { Page } from '@/components/Ui/Page';
import { PageHeader } from '@/components/Ui/PageHeader';
import { UiLink } from '@/components/Ui/UiLink';

export function AccountNotFoundScreen() {
  const { t } = useTranslation();
  return (
    <Page>
      <PageHeader title={t('ui.notFoundTitle')} />
      <EmptyText>
        {t('ui.notFoundBody')} <UiLink to="/account">{t('nav.home')}</UiLink>
      </EmptyText>
    </Page>
  );
}
